const downsizeCurrencySymbols = () => {
    const priceItems = document.querySelectorAll('.price, .price--end, .product-price, .totals__subtotal-value, .downsized, .grid-product__price--original, .shipping-yen, .price-item, .price-item--regular');
    
    priceItems.forEach((priceItem) => {
        if (priceItem.classList.contains('downsized')) return;

        // ¥がすでに <span class="mini-symbol"> で囲まれていないかチェック
        if (!priceItem.innerHTML.includes('<span class="mini-symbol">')) {
            priceItem.innerHTML = priceItem.innerHTML.replace(/¥(?!<\/span>)/g, '<span class="mini-symbol">¥</span>');
        }

        priceItem.classList.add('downsized');
    });
};

window.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver((mutationsList, observer) => {
        observer.disconnect();
        downsizeCurrencySymbols(); 
        observer.observe(document.body, config);
    });

    const config = {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
    };

    downsizeCurrencySymbols();
    observer.observe(document.body, config);
});

// スタイルに貼り付け
// .mini-symbol{
//   font-size:0.7em;
// }